import React, { useState } from 'react';
import {
  AutocompleteArrayInput,
  DateInput,
  ReferenceInput,
  TextInput,
  useTranslate,
  SelectInput,
} from 'react-admin';
import { Form } from 'react-final-form';
import moment from 'moment';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Typography,
  useMediaQuery,
  Grid,
  FormControl,
  Select,
  Switch,
  FormControlLabel,
  withStyles,
  InputAdornment,
} from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import PlaceIcon from '@material-ui/icons/Place';
import FaceIcon from '@material-ui/icons/Face';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import CloseIcon from '@material-ui/icons/Close';
import DollarSignIcon from '@material-ui/icons/AttachMoney';

import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import { getZ3PConfigValue, perPage } from '../../helper';
import ReferenceChild from '../../components/ReferenceChild';
import { printCustomer } from '../customer';
import SwBulkActionButtons from '../../components/SwBulkActionButtons';

const useStyles = makeStyles(() => ({
  root: {
    order: -1,
    minWidth: '215px',
    width: '100%',
    marginRight: '1em',
    '& .MuiFormLabel-root': {
      fontWeight: 'bold !important',
      color: '#000000 !important',
    },
    '& .MuiFormControlLabel-label': {
      fontWeight: 'bold !important',
      color: '#000000 !important',
    },
  },
  listItem: {
    paddingLeft: '2em',
  },
  listItemText: {
    margin: 0,
  },
  cursorHand: { cursor: 'pointer' },
  listGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '50%',
  },
  listClear: {
    fontSize: '1.1rem',
  },
  listClearBtn: {
    marginBottom: '18px',
  },
  switchLableColor: {
    color: '#000000 !important',
    fontWeight: 'bold !important',
  },
}));

const PaymentSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 18,
    padding: 0,
    margin: 9,
  },
  switchBase: {
    padding: 3,
    color: theme.palette.common.white,
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: '#00A76F',
        borderColor: '#00A76F',
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid rgba(145, 158, 171, 0.48)`,
    borderRadius: 50,
    opacity: 1,
    backgroundColor: `rgba(145, 158, 171, 0.48)`,
    height: 'auto',
  },
  checked: {},
}))(Switch);

const SearchTextInput = (props) => (
  <TextInput
    {...props}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <svg
            className="search_icon"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M20.71 19.29L17.31 15.9C18.407 14.5025 19.0022 12.7767 19 11C19 9.41775 18.5308 7.87103 17.6518 6.55544C16.7727 5.23985 15.5233 4.21447 14.0615 3.60897C12.5997 3.00347 10.9911 2.84504 9.43928 3.15372C7.88743 3.4624 6.46197 4.22433 5.34315 5.34315C4.22433 6.46197 3.4624 7.88743 3.15372 9.43928C2.84504 10.9911 3.00347 12.5997 3.60897 14.0615C4.21447 15.5233 5.23985 16.7727 6.55544 17.6518C7.87103 18.5308 9.41775 19 11 19C12.7767 19.0022 14.5025 18.407 15.9 17.31L19.29 20.71C19.383 20.8037 19.4936 20.8781 19.6154 20.9289C19.7373 20.9797 19.868 21.0058 20 21.0058C20.132 21.0058 20.2627 20.9797 20.3846 20.9289C20.5064 20.8781 20.617 20.8037 20.71 20.71C20.8037 20.617 20.8781 20.5064 20.9289 20.3846C20.9797 20.2627 21.0058 20.132 21.0058 20C21.0058 19.868 20.9797 19.7373 20.9289 19.6154C20.8781 19.4936 20.8037 19.383 20.71 19.29ZM5 11C5 9.81332 5.3519 8.65328 6.01119 7.66658C6.67047 6.67989 7.60755 5.91085 8.7039 5.45673C9.80026 5.0026 11.0067 4.88378 12.1705 5.11529C13.3344 5.3468 14.4035 5.91825 15.2426 6.75736C16.0818 7.59648 16.6532 8.66558 16.8847 9.82946C17.1162 10.9933 16.9974 12.1997 16.5433 13.2961C16.0892 14.3925 15.3201 15.3295 14.3334 15.9888C13.3467 16.6481 12.1867 17 11 17C9.4087 17 7.88258 16.3679 6.75736 15.2426C5.63214 14.1174 5 12.5913 5 11Z"
              fill="#919EAB"
            />
          </svg>
        </InputAdornment>
      ),
    }}
  />
);

const AsideFilters = (props) => {
  const { filterValues, setFilters, data } = props;
  const uniqueSources = [...new Set(Object.values(data).map(item => item.source))];
  const sourceMap = {
    'MSS': { id: 'mss', name: 'MSS Appointments' },
    'Amazon': { id: 'amazon', name: 'Amazon Appointments' },
    'Simple': { id: 'st', name: 'ST appointments' }, // Mapping "Simple" to "ST"
    'InShop': { id: 'shop', name: 'In-Shop appointments' }
  };
  const formattedSources = [
    { id: 'all', name: 'All' },
    ...uniqueSources
      .filter(source => sourceMap[source]) // Ensure the source exists in our map
      .map(source => sourceMap[source])
  ];
  console.log(JSON.stringify(formattedSources));

  const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const classes = useStyles();
  const translate = useTranslate();
  // const [showServiceVehicle, setShowServiceVehicle] = useState(false);
  // const [showLocation, setShowLocation] = useState(false);
  // const [showCustomer, setShowCustomer] = useState(false);
  // const [showEmployee, setShowEmployee] = useState(false);

  const setFilter = (values) => {
    setFilters({ ...filterValues, ...values });
  };
  const onSearchChange = (event) => {
    setFilter({ q: event.target ? event.target.value : undefined });
  };

  const onSearchBySource = (event) => {
    if (event.target.value == 'all') {
      setFilter({ source: undefined });
    } else if (event.target.value == 'shop') {
      setFilter({ source: 'InShop' });
    } else if (event.target.value == 'mss') {
      setFilter({ source: 'MSS' });
    } else if (event.target.value == 'amazon') {
      setFilter({ source: 'Amazon' });
    } else if (event.target.value == 'st') {
      setFilter({ source: 'Simple' });
    }
  };

  const onAppointmentSearchChange = (event) => {
    setFilter({
      appointment_id: event.target ? event.target.value : undefined,
    });
  };

  const onAppointmentSearchChangeBySTOrderId = (event) => {
    setFilter({
      st_order_id: event.target ? event.target.value : undefined,
    });
  };

  const onAppointmentSearchChangeByAmazonServiceId = (event) => {
    setFilter({
      service_order_id: event.target ? event.target.value : undefined,
    });
  };

  const onChange = (event, name) => {
    if (event && event.target) {
      setFilter({
        [name]:
          event.target && event.target.value ? event.target.value : undefined,
      });
    } else {
      setFilter({
        [name]: event || undefined,
      });
    }
  };
  const onSubmit = () => undefined;

  // defining this component here allows to skip passing filterValues and setFilter as props
  const FilterButton = (thisProps) => {
    const { label, value, type = '' } = thisProps;
    const isSelected = Object.keys(value).reduce(
      (acc, key) => acc && value[key] == filterValues[key], // eslint-disable-line eqeqeq
      true,
    );
    const toggleFilter = () => {
      if (isSelected) {
        // remove the filter
        const inverseValues = Object.keys(value).reduce((acc, key) => {
          acc[key] = undefined;
          return acc;
        }, {});
        setFilter(inverseValues);
      } else {
        setFilter(value);
      }
      console.log(isSelected);
    };
    if (type === 'payment_due') {
      return (
        <FormControlLabel
          control={
            <PaymentSwitch checked={isSelected} onChange={toggleFilter} />
          }
          label="Payment Due"
          className={classes.switchLableColor}
        />
      );
    }
    return (
      <ListItem
        button
        onClick={toggleFilter}
        selected={isSelected}
        className={classes.listItem}
      >
        <ListItemText
          primary={translate(label)}
          className={classes.listItemText}
        />
        {isSelected && (
          <ListItemSecondaryAction>
            <IconButton size="small" onClick={toggleFilter}>
              <CloseIcon color="primary" className={classes.listClear} />
            </IconButton>
          </ListItemSecondaryAction>
        )}
      </ListItem>
    );
  };
  const getDateRangeType = (startDate, endDate) => {
    const today = moment();
    const tomorrow = moment().add(1, 'days');

    // Start and end of the current week (assuming Monday as the first day of the week)
    const startOfThisWeek = moment().startOf('week'); // You can change 'week' start to 'isoWeek' if you want Monday as the first day.
    const endOfThisWeek = moment().endOf('week');

    // Start and end of last week
    const startOfLastWeek = moment()
      .subtract(1, 'weeks')
      .startOf('week');
    const endOfLastWeek = moment()
      .subtract(1, 'weeks')
      .endOf('week');

    // Start and end of the current month
    const startOfThisMonth = moment().startOf('month');
    const endOfThisMonth = moment().endOf('month');

    // Start and end of last month
    const startOfLastMonth = moment()
      .subtract(1, 'months')
      .startOf('month');
    const endOfLastMonth = moment()
      .subtract(1, 'months')
      .endOf('month');

    // Parse input dates
    const start = moment(startDate);
    const end = moment(endDate);

    // Check if the range corresponds to "Today"
    if (start.isSame(today, 'day') && end.isSame(today, 'day')) {
      return 'today';
    }

    // Check if the range corresponds to "Tomorrow"
    if (start.isSame(tomorrow, 'day') && end.isSame(tomorrow, 'day')) {
      return 'tomorrow';
    }

    // Check if the range corresponds to "This Week"
    if (
      start.isBetween(startOfThisWeek, endOfThisWeek, null, '[]') &&
      end.isBetween(startOfThisWeek, endOfThisWeek, null, '[]')
    ) {
      return 'this_week';
    }

    // Check if the range corresponds to "Last Week"
    if (
      start.isBetween(startOfLastWeek, endOfLastWeek, null, '[]') &&
      end.isBetween(startOfLastWeek, endOfLastWeek, null, '[]')
    ) {
      return 'last_week';
    }

    // Check if the range corresponds to "This Month"
    if (
      start.isBetween(startOfThisMonth, endOfThisMonth, null, '[]') &&
      end.isBetween(startOfThisMonth, endOfThisMonth, null, '[]')
    ) {
      return 'this_month';
    }

    // Check if the range corresponds to "Last Month"
    if (
      start.isBetween(startOfLastMonth, endOfLastMonth, null, '[]') &&
      end.isBetween(startOfLastMonth, endOfLastMonth, null, '[]')
    ) {
      return 'last_month';
    }

    // Check if the range corresponds to "Date Range" (past 15 days to next 15 days)
    const past15Days = moment().subtract(15, 'days');
    const next15Days = moment().add(15, 'days');
    if (start.isSame(past15Days, 'day') && end.isSame(next15Days, 'day')) {
      return 'range';
    }

    // If none match, return 'range' (default)
    return 'range';
  };

  const onChangeDateFilter = (event) => {
    const { value } = event.target;
    let start_date;
    let end_date;

    switch (value) {
      case 'range':
        start_date = moment().subtract(15, 'days').format('YYYY-MM-DD');
        end_date = moment().add(15, 'days').format('YYYY-MM-DD');
        break;
      case 'today':
        start_date = end_date = moment().format('YYYY-MM-DD');
        break;
      case 'tomorrow':
        start_date = end_date = moment()
          .add(1, 'days')
          .format('YYYY-MM-DD');
        break;
      case 'this_week':
        start_date = moment()
          .startOf('week')
          .format('YYYY-MM-DD');
        end_date = moment()
          .endOf('week')
          .format('YYYY-MM-DD');
        break;
      case 'last_week':
        start_date = moment()
          .subtract(1, 'weeks')
          .startOf('week')
          .format('YYYY-MM-DD');
        end_date = moment()
          .subtract(1, 'weeks')
          .endOf('week')
          .format('YYYY-MM-DD');
        break;
      case 'this_month':
        start_date = moment()
          .startOf('month')
          .format('YYYY-MM-DD');
        end_date = moment()
          .endOf('month')
          .format('YYYY-MM-DD');
        break;
      case 'last_month':
        start_date = moment()
          .subtract(1, 'months')
          .startOf('month')
          .format('YYYY-MM-DD');
        end_date = moment()
          .subtract(1, 'months')
          .endOf('month')
          .format('YYYY-MM-DD');
        break;
      default:
        start_date = end_date = '';
        break;
    }

    const dateRange = {
      start_date,
      end_date,
    };

    const isSelected = Object.keys(dateRange).reduce(
      (acc, key) => acc && dateRange[key] == filterValues[key], // eslint-disable-line eqeqeq
      true,
    );

    if (isSelected) {
      // remove the filter
      const inverseValues = Object.keys(dateRange).reduce((acc, key) => {
        acc[key] = undefined;
        return acc;
      }, {});
      setFilter(inverseValues);
    } else {
      setFilter(dateRange);
    }
  };

  const FilterContainer = (thisProps) => {
    const { value } = thisProps;
    const isSelected = Object.keys(filterValues).includes(value);
    const removeFilter = () => {
      if (isSelected) {
        const removeObj = {};
        removeObj[value] = undefined;
        setFilter(removeObj);
      }
    };
    return (
      <>
        {isSelected && (
          <IconButton
            size="small"
            onClick={removeFilter}
            className={classes.listClearBtn}
          >
            <CloseIcon color="primary" className={classes.listClear} />
          </IconButton>
        )}
      </>
    );
  };

  // const serviceLocations = getZ3PConfigValue('service_locations');
  // const hasWorkplaceServices = serviceLocations?.includes('workplace');
  // const hasShopServices = serviceLocations?.includes('shop');
  // const isUsingWaitList = getZ3PConfigValue('is_using_waitlist');

  return (
    <Card className={`card-box ${classes.root}`}>
      <CardContent>
        <Grid container direction="row" spacing={2} alignItems="center">
          <Grid container item xs={6} md={3} lg={2}>
            <Form onSubmit={onSubmit}>
              {() => (
                <div className="filter_input_box filter_items">
                  <AccessTimeIcon className="filter_input_icons" />
                  <SelectInput
                    source="date_filter"
                    choices={[
                      { id: 'all', name: 'All' },
                      { id: 'range', name: 'Date Range' },
                      { id: 'today', name: 'Today' },
                      { id: 'tomorrow', name: 'Tomorrow' },
                      { id: 'this_week', name: 'This Week' },
                      { id: 'last_week', name: 'Last Week' },
                      { id: 'this_month', name: 'This Month' },
                      { id: 'last_month', name: 'Last Month' },
                    ]}
                    onChange={(e) => onChangeDateFilter(e)}
                    defaultValue={getDateRangeType(
                      filterValues.start_date,
                      filterValues.end_date,
                    )}
                  />
                </div>
              )}
            </Form>
          </Grid>
          <Grid container item xs={6} md={5} lg={4}>
            <Form onSubmit={onSubmit} initialValues={filterValues}>
              {() => (
                <>
                  <div className={classes.listGroup}>
                    <DateInput
                      source="start_date"
                      onChange={(e) => onChange(e, 'start_date')}
                      className="date_filter_box"
                    />
                    <FilterContainer value="start_date" />
                  </div>
                  <div className={classes.listGroup}>
                    <DateInput
                      source="end_date"
                      onChange={(e) => onChange(e, 'end_date')}
                      className="date_filter_box"
                    />
                    <FilterContainer value="end_date" />
                  </div>
                </>
              )}
            </Form>
          </Grid>
          <Grid container item xs={6} md={4} lg={3}>
            <Form onSubmit={onSubmit} initialValues={filterValues}>
              {() => (
                <div className="filter_input_box status_filter_box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="filter_input_icons"
                  >
                    <path
                      d="M11.795 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H17C17.5304 5 18.0391 5.21071 18.4142 5.58579C18.7893 5.96086 19 6.46957 19 7V11H3M18 14V18H22M18 14C19.0609 14 20.0783 14.4214 20.8284 15.1716C21.5786 15.9217 22 16.9391 22 18M18 14C16.9391 14 15.9217 14.4214 15.1716 15.1716C14.4214 15.9217 14 16.9391 14 18C14 19.0609 14.4214 20.0783 15.1716 20.8284C15.9217 21.5786 16.9391 22 18 22C19.0609 22 20.0783 21.5786 20.8284 20.8284C21.5786 20.0783 22 19.0609 22 18M15 3V7M7 3V7"
                      stroke="#919EAB"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <AutocompleteArrayInput
                    source="status_is_in"
                    label="status"
                    placeholder="All Statuses"
                    choices={[
                      { id: 'scheduled', name: 'Scheduled' },
                      ...(filterValues.st_order_id
                        ? []
                        : [{ id: 'keys_available', name: 'Keys Available' }]),
                      { id: 'finished', name: 'Complete' },
                      { id: 'cancelled', name: 'Cancelled' },
                      ...(filterValues.st_order_id
                        ? []
                        : [{ id: 'suggested', name: 'Suggested' }]),
                    ]}
                    onChange={(e) => onChange(e, 'status_is_in')}
                  />
                </div>
              )}
            </Form>
          </Grid>
          {/* <Grid container item xs={6} md={4} lg={3}>
            <Form onSubmit={onSubmit} initialValues={filterValues}>
              {() => (
                <div className="filter_input_box filter_items">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="filter_input_icons"
                  >
                    <path
                      d="M13 5H21M13 9H18M13 15H21M13 19H18M3 5C3 4.73478 3.10536 4.48043 3.29289 4.29289C3.48043 4.10536 3.73478 4 4 4H8C8.26522 4 8.51957 4.10536 8.70711 4.29289C8.89464 4.48043 9 4.73478 9 5V9C9 9.26522 8.89464 9.51957 8.70711 9.70711C8.51957 9.89464 8.26522 10 8 10H4C3.73478 10 3.48043 9.89464 3.29289 9.70711C3.10536 9.51957 3 9.26522 3 9V5ZM3 15C3 14.7348 3.10536 14.4804 3.29289 14.2929C3.48043 14.1054 3.73478 14 4 14H8C8.26522 14 8.51957 14.1054 8.70711 14.2929C8.89464 14.4804 9 14.7348 9 15V19C9 19.2652 8.89464 19.5196 8.70711 19.7071C8.51957 19.8946 8.26522 20 8 20H4C3.73478 20 3.48043 19.8946 3.29289 19.7071C3.10536 19.5196 3 19.2652 3 19V15Z"
                      stroke="#919EAB"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <ReferenceInput
                    source="service_vehicle_id"
                    reference="service-vehicle"
                    sort={{ field: 'name', order: 'ASC' }}
                    filter={{ is_active: true }}
                    perPage={perPage}
                    allowEmpty
                    label="Service bays & vehicles"
                    className="service_vehicle_id"
                  >
                    <ReferenceChild
                      {...props}
                      optionText="name"
                      source="service_vehicle_id"
                      onChange={(e) => onChange(e, 'service_vehicle_id')}
                    />
                  </ReferenceInput>
                </div>
              )}
            </Form>
          </Grid> */}


          <Grid container item xs={6} md={4} lg={3}>
            {/* {(showCustomer || filterValues.customer_id) && ( */}
            <Form onSubmit={onSubmit} initialValues={filterValues}>
              {() => (
                <div className="filter_input_box filter_items">
                  <PersonOutlineOutlinedIcon className="filter_input_icons" />
                  <ReferenceInput
                    source="customer_id"
                    reference="customer"
                    perPage={perPage}
                    allowEmpty
                    className="customer_id"
                  >
                    <ReferenceChild
                      {...props}
                      optionText={(choice) => printCustomer(choice)}
                      source="customer_id"
                      onChange={(e) => onChange(e, 'customer_id')}
                    />
                  </ReferenceInput>
                </div>
              )}
            </Form>
            {/* )} */}
          </Grid>
          {/* <Grid container item xs={6} md={4} lg={3}>
            <Form onSubmit={onSubmit} initialValues={filterValues}>
              {() => (
                <div className="filter_input_box filter_items">
                  <PersonOutlineOutlinedIcon className="filter_input_icons" />
                  <ReferenceInput
                    source="created_by_employee_id"
                    reference="employee"
                    sort={{ field: 'created_by_employee_id', order: 'ASC' }}
                    perPage={perPage}
                    allowEmpty
                  >
                    <ReferenceChild
                      {...props}
                      optionText="email_address"
                      source="created_by_employee_id"
                      onChange={(e) => onChange(e, 'created_by_employee_id')}
                    />
                  </ReferenceInput>
                </div>
              )}
            </Form>
          </Grid> */}
          <Grid container item xs={4} md={6} lg={2}>
            {!isSmall && (
              <Form onSubmit={onSubmit} initialValues={filterValues}>
                {() => (
                  <>
                    <SearchTextInput
                      source="appointment_id"
                      label="Search by Appointment ID"
                      onChange={onAppointmentSearchChange}
                      resettable
                      helperText
                    />
                  </>
                )}
              </Form>
            )}
          </Grid>
          <Grid container item xs={4} md={6} lg={2}>
            {!isSmall && (
              <Form onSubmit={onSubmit} initialValues={filterValues}>
                {() => (
                  <>
                    <SearchTextInput
                      source="q"
                      label="Search by Vehicle Info"
                      onChange={onSearchChange}
                      resettable
                      helperText
                    />
                  </>
                )}
              </Form>
            )}
          </Grid>
          <Grid container item xs={6} md={3} lg={2}>
            <Form onSubmit={onSubmit}>
              {() => (
                <div className="filter_input_box filter_items">
                  <AccessTimeIcon className="filter_input_icons" />
                  <SelectInput
                    // source="st_order_id"
                    source="source"
                    label="Search by source"
                    choices={formattedSources}
                    onChange={onSearchBySource}
                  />
                </div>
              )}
            </Form>
          </Grid>
          <Grid container item xs={4} md={6} lg={2}>
            {!isSmall && (
              <Form onSubmit={onSubmit} initialValues={filterValues}>
                {() => (
                  <>
                    <SearchTextInput
                      source="st_order_id"
                      label="Search by ST Order ID"
                      onChange={onAppointmentSearchChangeBySTOrderId}
                      resettable
                      helperText
                    />
                  </>
                )}
              </Form>
            )}
          </Grid>
          <Grid container item xs={4} md={6} lg={2}>
            {!isSmall && (
              <Form onSubmit={onSubmit} initialValues={filterValues}>
                {() => (
                  <>
                    <SearchTextInput
                      source="service_order_id"
                      label="Search by Amazon Service ID"
                      onChange={onAppointmentSearchChangeByAmazonServiceId}
                      resettable
                      helperText
                    />
                  </>
                )}
              </Form>
            )}
          </Grid>
          <Grid container item xs={6} md={4} lg={2}>
            <Box>
              <FilterButton
                value={{ payment_due: true }}
                label="ra.boolean.true"
                type="payment_due"
              />
              <p>
                <span>​</span>
              </p>
            </Box>
          </Grid>
        </Grid>
        {props.selectedIds.length == 0 ? (
          <Box
            style={{
              border: '0.5px dashed lightgray',
              borderRadius: '10px',
              // opacity: 0.5,
              padding: 10,
              margin: 2,
              marginTop: 30,
            }}
          >
            <SwBulkActionButtons />
          </Box>
        ) : (
          <></>
        )}
        {/* <Grid item xs={6} key={4}>
          <Paper elevation={0} style={{ border: '1px solid #ccc', padding: '16px', textAlign: 'center' }}>
          <SwBulkActionButtons />
          </Paper>
        </Grid> */}
        {/* <Grid container item xs={6} md={3} lg={2}>
            <Paper className={classes.paperBase}>
        <Grid className="unifiedWrapper">
          <Grid container spacing={0}>
          <Grid item xs={12} md={8} xl={8}>
              
            </Grid>
          </Grid>
        </Grid>
      </Paper>
          </Grid> */}

        {/*  <FilterSection
          icon={AccessTimeIcon}
          label="resources.scheduled-work.filters.date_filter"
        />
        <List dense disablePadding>
          <FilterButton
            value={{
              start_date: moment().format('YYYY-MM-DD'),
              end_date: moment().format('YYYY-MM-DD'),
            }}
            label="resources.scheduled-work.filters.today"
          />
          <FilterButton
            value={{
              start_date: moment()
                .add(1, 'days')
                .format('YYYY-MM-DD'),
              end_date: moment()
                .add(1, 'days')
                .format('YYYY-MM-DD'),
            }}
            label="resources.scheduled-work.filters.tomorrow"
          />
          <FilterButton
            value={{
              start_date: moment()
                .startOf('week')
                .format('YYYY-MM-DD'),
              end_date: moment()
                .endOf('week')
                .format('YYYY-MM-DD'),
            }}
            label="resources.scheduled-work.filters.this_week"
          />
          <FilterButton
            value={{
              start_date: moment()
                .subtract(1, 'weeks')
                .startOf('week')
                .format('YYYY-MM-DD'),
              end_date: moment()
                .subtract(1, 'weeks')
                .endOf('week')
                .format('YYYY-MM-DD'),
            }}
            label="resources.scheduled-work.filters.last_week"
          />
         
        </List>
       
        {isUsingWaitList && (
          <>
            <FilterSection
              icon={AccessTimeIcon}
              label="resources.scheduled-work.filters.needs_date"
            />
            <List dense disablePadding>
              <FilterButton
                value={{ date_is_null: true }}
                label="ra.boolean.true"
              />
              <FilterButton
                value={{ date_is_null: false }}
                label="ra.boolean.false"
              />
            </List>
          </>
        )}
        <FilterSection
          icon={DollarSignIcon}
          label="resources.scheduled-work.filters.payment_due"
        />
        <List dense disablePadding>
          <FilterButton value={{ payment_due: true }} label="ra.boolean.true" />
        </List>
       
        {(showServiceVehicle || filterValues.service_vehicle_id) && (
          
        )}
        {(hasWorkplaceServices || hasShopServices) && (
          <FilterSection
            icon={PlaceIcon}
            label="resources.scheduled-work.filters.client_location"
            handleClick={() => setShowLocation((prev) => !prev)}
          />
        )}
        {(showLocation || filterValues.client_location_id) && (
          <div className={classes.listGroup}>
            <Form onSubmit={onSubmit} initialValues={filterValues}>
              {() => (
                <ReferenceInput
                  source="client_location_id"
                  label={hasWorkplaceServices ? 'Client location' : 'Shop'}
                  reference="client-location"
                  sort={{ field: 'client_location_id', order: 'ASC' }}
                  perPage={perPage}
                  allowEmpty
                >
                  <ReferenceChild
                    {...props}
                    optionText="short_name"
                    source="client_location_id"
                    onChange={(e) => onChange(e, 'client_location_id')}
                  />
                </ReferenceInput>
              )}
            </Form>
            <FilterContainer value="client_location_id" />
          </div>
        )}
        <FilterSection
          icon={FaceIcon}
          label="resources.scheduled-work.filters.customer"
          handleClick={() => setShowCustomer((prev) => !prev)}
        />
        {(showCustomer || filterValues.customer_id) && (
          <div className={classes.listGroup}>
            <Form onSubmit={onSubmit} initialValues={filterValues}>
              {() => (
                <ReferenceInput
                  source="customer_id"
                  reference="customer"
                  perPage={perPage}
                >
                  <ReferenceChild
                    {...props}
                    optionText={(choice) => printCustomer(choice)}
                    source="customer_id"
                    onChange={(e) => onChange(e, 'customer_id')}
                  />
                </ReferenceInput>
              )}
            </Form>
            <FilterContainer value="customer_id" />
          </div>
        )}
        <FilterSection
          icon={SupervisedUserCircleIcon}
          label="resources.scheduled-work.filters.created_by_employee"
          handleClick={() => setShowEmployee((prev) => !prev)}
        />
        {(showEmployee || filterValues.created_by_employee_id) && (
          <div className={classes.listGroup}>
            <Form onSubmit={onSubmit} initialValues={filterValues}>
              {() => (
                <ReferenceInput
                  source="created_by_employee_id"
                  reference="employee"
                  sort={{ field: 'created_by_employee_id', order: 'ASC' }}
                  perPage={perPage}
                  allowEmpty
                >
                  <ReferenceChild
                    {...props}
                    optionText="email_address"
                    source="created_by_employee_id"
                    onChange={(e) => onChange(e, 'created_by_employee_id')}
                  />
                </ReferenceInput>
              )}
            </Form>
            <FilterContainer value="created_by_employee_id" />
          </div>
        )}
        */}
      </CardContent>
    </Card>
  );
};

export default AsideFilters;

// const FilterSection = ({ label, icon: Icon, handleClick = null }) => {
//   const classes = useStyles();
//   const translate = useTranslate();
//   return (
//     <Box
//       mt={2}
//       display="flex"
//       alignItems="center"
//       onClick={handleClick}
//       className={handleClick ? classes.cursorHand : ''}
//     >
//       <Box mr={1}>
//         <Icon color="primary" />
//       </Box>
//       <Typography variant="h6">{translate(label)}</Typography>
//     </Box>
//   );
// };
